import React, { useRef, useState } from 'react';
import RaList from '../../components/ra-list/RaList';
import RenderControls from '../../components/ra-list/RenderControls';
import { Datagrid, FunctionField, TextField } from 'react-admin';
import { loadSourceType, reloadPage } from '../../utils/common';
import { dataProvider } from '../../DataProvider';
import { dayjs, formatDateTime, formatLocalTime, toLocalTime } from '../../components/ex_dayjs';
import { ExchangeMarket } from '../../utils/enum';
import EditableStatusField from './components/editable-tags';
import TagActions from './components/tag-actions';

const SmEventCheck = () => {
    const refbtnFilter = useRef(null);
    const extendedExchangeMarket = ExchangeMarket.concat({ id: 999, name: 'Our Database' });
    const [marketType, setMarketType] = useState<any[]>([]);
    const [filterConfig, setFilterConfig] = useState({ missingEvent: false, firstName: null });
    const [defaultFilter] = useState({
        event_date: [dayjs(), dayjs().add(6, 'M')],
        exchange_src_eq: 1,
        exchange_des_eq: 13,
        missing_type_eq: 0,
        skip_tags_eq: true,
        sm_tags_contains: []
    });
    const [defaultSort, setDefaulSort] = useState(['mapped_date desc']);
    const MissingTypes = [
        { id: -1, name: 'Any' },
        { id: 0, name: 'Unmatched (Not in our DB + Excluding restricted events)' },
        { id: 1, name: 'Restricted (events from csv merge)' },
    ];
    const MissingTags = ['In Progress', 'Skip', 'Added'];

    React.useEffect(() => {
        loadSourceType(dataProvider, response => {
            setMarketType(response);
        });
    }, []);

    const reloadMainPage = () => {
        reloadPage('SmEventCheck', refbtnFilter);
    };

    const handleCompareMissingEvent = (prop) => {
        setFilterConfig({ ...filterConfig, missingEvent: prop.value === 999 });
        setDefaulSort(prop.value === 999 ? ['sm_event_date desc'] : ['mapped_date desc']);
    };

    const missEventON = filterConfig.missingEvent;
    const controlFilters = [
        { component: 'select', name: 'exchange_src_eq', label: 'Source Exchange', choices: ExchangeMarket, xs: 1.3, isEmptyOption: false },
        {
            component: 'select', name: 'exchange_des_eq', label: missEventON ? 'Destination Source' : 'Destination Exchange',
            choices: extendedExchangeMarket, xs: 1.3, isEmptyOption: false, onChange: handleCompareMissingEvent
        },
        { component: 'text', name: 'event_name_contains', label: 'Name' },
        { component: 'text', name: 'event_venue_contains', label: 'Venue' },
        { component: 'daterange', name: 'event_date', label: 'Date Time' },
        {
            component: 'autocomplete', name: 'sm_tags_contains', label: 'Tags', xs: 3, choices: MissingTags, isHide: !missEventON
            //getStyles: getStyles, onChange: handleSelection
        },
        { component: '', name: '', xs: 3, isHide: missEventON },
        { component: 'number', name: 'sm_original_id_eq', label: 'SM Event ID', isHide: !missEventON, xs: 1.3 },
        { component: 'select', name: 'missing_type_eq', label: 'Missing Type', choices: MissingTypes, xs: 3.3, isEmptyOption: false, isHide: !missEventON },
        { component: 'checkbox', name: 'skip_tags_eq', label: 'Skip tags', isHide: !missEventON },
        { component: 'select', name: 'market_type_eq', label: 'Type', choices: marketType, xs: 1.3, isHide: missEventON },
        { component: 'daterange', name: 'mapped_date', label: 'Mapped Time', isHide: missEventON },
        { component: 'text', name: 'mapped_by_contains', label: 'By', isHide: missEventON },
    ];

    const exportCols = !missEventON
        ? ['market_type', 'sm_original_id', 'event_name', 'sm_event_name', 'event_venue', 'sm_event_venue', 'event_city', 'sm_event_city',
            'event_state', 'sm_event_state', 'event_date', 'mapped_by', 'mapped_date', 'sm_event_date', 'event_url', 'sm_event_url']
        : ['sm_original_id', 'sm_event_name', 'sm_event_venue', 'sm_event_city', 'sm_event_state', 'sm_event_date', 'sm_event_url', 'missing_type'];
    
    return (
        <>
            <RaList
                perPage={25}
                title={'Event Comparison Tool'}
                sortby={defaultSort}
                storeKey={true}
                filters={
                    <RenderControls
                        controls={controlFilters}
                        defaultValues={defaultFilter}
                        refFilter={refbtnFilter}
                        exportFile={{
                            filename: `SmEventCheck-${formatLocalTime(new Date(), 'YY-MM-DD')}`,
                            columns: exportCols,
                            limit: 1000000
                        }}
                    />

                }
            >
                <Datagrid
                    key={new Date()}
                    bulkActionButtons={missEventON && <TagActions display={missEventON} tags={MissingTags} reload={reloadMainPage} />}
                >
                    {/* break line for filter button */}
                    {!missEventON && <TextField source="market_type" label={'Type'} />}
                    <TextField source="sm_original_id" label={'Sm EventID'} />
                    {!missEventON && (<FunctionField source="event_name" label={'Name'} render={record =>
                        <a href={record.event_url} target="_blank" style={{ color: record.event_url ? 'orange' : '' }}>{record.event_name}</a>}
                    />)}
                    <FunctionField source="sm_event_name" label={'SmEvent'} render={record =>
                        <a href={record.sm_event_url} target="_blank" style={{ color: record.sm_event_url ? 'orange' : '' }}>{record.sm_event_name}</a>}
                    />
                    {!missEventON && <TextField source="event_venue" label={'Venue'} />}
                    <TextField source="sm_event_venue" label={'SmVenue'} />
                    {!missEventON && <TextField source="event_city" label={'City'} />}
                    <TextField source="sm_event_city" label={'SmCity'} />
                    {!missEventON && <TextField source="event_state" label={'State'} />}
                    <TextField source="sm_event_state" label={'SmState'} />
                    {!missEventON && (
                        <FunctionField label='DateTime' source='event_date' render={record => (<>{formatDateTime(record.event_date, 'MM-DD-YYYY')} <br />{formatDateTime(record.event_date, 'hh:mm A')}</>)} />
                    )}
                    <FunctionField label='SmDateTime' source='sm_event_date' render={record => (<>{formatDateTime(record.sm_event_date, 'MM-DD-YYYY')} <br />{formatDateTime(record.sm_event_date, 'hh:mm A')}</>)} />
                    {!missEventON && <TextField source="mapped_by" label={'By'} />}
                    {!missEventON && (
                        <FunctionField label='Mapped Time' source='mapped_date' render={record => (<>{formatDateTime(toLocalTime(record.mapped_date), 'MM-DD-YYYY')} <br />{formatDateTime(toLocalTime(record.mapped_date), 'hh:mm A')}</>)} />
                    )}
                    {/* eslint-disable-next-line eqeqeq -- missing_type may arrive as a numeric string from the API; loose match intentionally covers both 0 and '0' */}
                    {missEventON && <FunctionField source="missing_type" label={'Missing Type'} render={record => (record.missing_type == 0 ? 'Unmatched' : 'Restricted')} />}
                    {missEventON && <EditableStatusField source='sm_tags' label='Tags' tags={MissingTags} reload={reloadMainPage} />}
                </Datagrid>
            </RaList >
        </>

    );
};
const SmEventCheckPage = {
    name: 'SmEventCheck',
    list: SmEventCheck
};
export default SmEventCheckPage;